import apiConfig from '../apiConfig';
import { getAxiosInstance } from '../../utils/axiosApi';
import axios from 'axios';

const axiosInstance = getAxiosInstance({
  baseUrl: apiConfig.PortalAPIUrl,
});

const searchConsumableOrders = async (
  {
    purchaseOrderNumber,
    companyName,
    contractName,
    countryCode,
    assetID,
    imoNumber,
    userName,
    createdOnFrom,
    createdOnTo,
    lastUpdatedBy,
    lastUpdatedOnFrom,
    lastUpdatedOnTo,
    numberOfKits,
    awbNumber,
    dispatchedOnFrom,
    dispatchedOnTo,
    page,
    pageSize,
    sortBy,
  }
) => {
  const queryParams = [];

  if (companyName) {
    queryParams.push(`companyName=${encodeURIComponent(companyName)}`);
    queryParams.push('companyName=Contains');
  }

  if (contractName) {
    queryParams.push(`ContractID=${encodeURIComponent(contractName?.id)}`);
  }
  if (countryCode) {
    queryParams.push(`countryCode=${encodeURIComponent(countryCode)}`);
  }
  if (userName) {
    queryParams.push(`CreatedBy=${encodeURIComponent(userName)}`);
  }

  if (purchaseOrderNumber && purchaseOrderNumber.trim() !== '') {
    queryParams.push(`purchaseOrderNumber=${encodeURIComponent(purchaseOrderNumber.trim())}`);
    queryParams.push('purchaseOrderNumber=Contains');
  }

  if (imoNumber) {
    queryParams.push(`ImoNumber=${encodeURIComponent(imoNumber)}`);
    queryParams.push('ImoNumber=Contains');
  }

  if (assetID) {
    queryParams.push(`assetID=${assetID}`);
  }

  if (createdOnFrom) {
    queryParams.push(`createdOnFrom=${createdOnFrom}`);
  }

  if (createdOnTo) {
    queryParams.push(`createdOnTo=${createdOnTo}`);
  }

  if (lastUpdatedBy) {
    queryParams.push(`LastUpdatedBy=${lastUpdatedBy}`);
  }

  if (lastUpdatedOnFrom) {
    queryParams.push(`lastUpdatedOnFrom=${lastUpdatedOnFrom}`);
  }

  if (lastUpdatedOnTo) {
    queryParams.push(`lastUpdatedOnTo=${lastUpdatedOnTo}`);
  }

  if (dispatchedOnFrom) {
    queryParams.push(`dispatchedOnFrom=${dispatchedOnFrom}`);
  }

  if (dispatchedOnTo) {
    queryParams.push(`dispatchedOnTo=${dispatchedOnTo}`);
  }

  if (typeof numberOfKits === 'number' && Number.isInteger(numberOfKits)) {
    queryParams.push(`NoOfKits=${numberOfKits}`);
  }

  if (awbNumber) {
    queryParams.push(`awbNo=${encodeURIComponent(awbNumber)}`);
  }

  if (page) {
    queryParams.push(`currentPage=${page}`);
  }

  if (pageSize) {
    queryParams.push(`pageSize=${pageSize}`);
  }

  if (sortBy) {
    queryParams.push(`sortBy=${sortBy}`);
  }

  try {
    const response = await axiosInstance.get(
      `/ConsumableOrder/Search/By?${queryParams.join('&')}`
    );

    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};

const contractNamesAutoComplete = async (
  {
    contractName,
    contractNameOP,
    page,
    pageSize,
    sortBy
  } = {}
) => {
  const queryParams = [];

  if (contractName && contractName.trim() !== '') {
    queryParams.push(`contractName=${encodeURIComponent(contractName.trim())}`);
  }

  if (contractNameOP && contractNameOP.trim() !== '') {
    queryParams.push(`contractName=${encodeURIComponent(contractNameOP.trim())}`);
  }

  if (page) {
    queryParams.push(`currentPage=${page}`);
  }

  if (pageSize) {
    queryParams.push(`pageSize=${pageSize}`);
  }

  if (sortBy) {
    queryParams.push(`sortBy=${sortBy}`);
  }

  try {
    const response = await axiosInstance.get(`/Contract/AutoComplete?${queryParams.join('&')}`,);

    return response.data;
  } catch (e) {
    throw new Error('Unable to fetch Contract Names');
  }
};

const ConsumableOrderCreate = async (requestPayload) => {
  try {
    const response = await axiosInstance.post(
      '/ConsumableOrder/Create',
      requestPayload
    );

    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};

const ConsumableOrderCreateForm = async (formData) => {
  try {
    const response = await axiosInstance.post(
      '/ConsumableOrder/Create',
      formData,
      { headers: { Accept: 'application/json' } }
    );
    return response.data;
  } catch (e) {
    if (axios.isCancel(e)) {
      console.log('Request cancelled');
      return {};
    }
    throw e;
  }
};

const ConsumableOrderUpdate = async (requestPayload) => {
  try {
    const response = await axiosInstance.post(
      '/ConsumableOrder/Update',
      requestPayload
    );

    return response.data;
  } catch (e) {
    if (!axios.isCancel(e)) {
      throw e;
    }
  }

  return {};
};

const getConsumableOrderByConsumableOrderId = async (consumableOrderID) => {
  try {
    const response = await axiosInstance.get(`/ConsumableOrder/ConsumableOrderID/${consumableOrderID}/Detail`);
    return response.data;
  } catch (e) {
    throw new Error('Error getConsumableOrderByConsumableOrderId');
  }
};

const ConsumableOrderApi = {
  searchConsumableOrders,
  contractNamesAutoComplete,
  ConsumableOrderCreate,
  ConsumableOrderCreateForm,
  ConsumableOrderUpdate,
  getConsumableOrderByConsumableOrderId
};

export default ConsumableOrderApi;
